import * as api from '../../api/maintenance/publicPortal';
import { makeApiActionCreatorV3 } from '../utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'GLOBAL/PUBLIC_PORTAL';

export const FETCH_CONFIGURATION_PORTAL = createRequestTypes(
  `${namespace}/FETCH_CONFIGURATION_PORTAL`,
);

export const fetchConfigurationPortal = makeApiActionCreatorV3(
  api.fetchConfigurationPortal,
  FETCH_CONFIGURATION_PORTAL[START],
  FETCH_CONFIGURATION_PORTAL[SUCCESS],
  FETCH_CONFIGURATION_PORTAL[ERROR],
);

export const UPDATE_CONFIGURATION_PORTAL = createRequestTypes(
  `${namespace}/UPDATE_CONFIGURATION_PORTAL`,
);

export const updateConfigurationPortal = makeApiActionCreatorV3(
  api.updateConfigurationPortal,
  UPDATE_CONFIGURATION_PORTAL[START],
  UPDATE_CONFIGURATION_PORTAL[SUCCESS],
  UPDATE_CONFIGURATION_PORTAL[ERROR],
);

export const FETCH_CONFIGURATION_APPEAL = createRequestTypes(
  `${namespace}/FETCH_CONFIGURATION_APPEAL`,
);
export const fetchConfigurationAppeal = makeApiActionCreatorV3(
  api.fetchConfigurationAppeal,
  FETCH_CONFIGURATION_APPEAL[START],
  FETCH_CONFIGURATION_APPEAL[SUCCESS],
  FETCH_CONFIGURATION_APPEAL[ERROR],
);

export const UPDATE_CONFIGURATION_APPEAL = createRequestTypes(
  `${namespace}/UPDATE_CONFIGURATION_APPEAL`,
);
export const updateConfigurationAppeal = makeApiActionCreatorV3(
  api.updateConfigurationAppeal,
  UPDATE_CONFIGURATION_APPEAL[START],
  UPDATE_CONFIGURATION_APPEAL[SUCCESS],
  UPDATE_CONFIGURATION_APPEAL[ERROR],
);

export const FETCH_CONFIGURATION_EMAIL = createRequestTypes(
  `${namespace}/FETCH_CONFIGURATION_EMAIL`,
);
export const fetchConfigurationEmail = makeApiActionCreatorV3(
  api.fetchConfigurationEmail,
  FETCH_CONFIGURATION_EMAIL[START],
  FETCH_CONFIGURATION_EMAIL[SUCCESS],
  FETCH_CONFIGURATION_EMAIL[ERROR],
);

export const UPDATE_CONFIGURATION_EMAIL = createRequestTypes(
  `${namespace}/UPDATE_CONFIGURATION_EMAIL`,
);
export const updateConfigurationEmail = makeApiActionCreatorV3(
  api.updateConfigurationEmail,
  UPDATE_CONFIGURATION_EMAIL[START],
  UPDATE_CONFIGURATION_EMAIL[SUCCESS],
  UPDATE_CONFIGURATION_EMAIL[ERROR],
);

export const FETCH_ALL_PUBLIC_CHECK_CONFIG = createRequestTypes(
  `${namespace}/FETCH_ALL_PUBLIC_CHECK_CONFIG`,
);
export const fetchAllPublicCheckInConfig = makeApiActionCreatorV3(
  api.fetchAllPublicCheckInConfig,
  FETCH_ALL_PUBLIC_CHECK_CONFIG[START],
  FETCH_ALL_PUBLIC_CHECK_CONFIG[SUCCESS],
  FETCH_ALL_PUBLIC_CHECK_CONFIG[ERROR],
);

export const FETCH_PUBLIC_CHECK_CONFIG = createRequestTypes(
  `${namespace}/FETCH_PUBLIC_CHECK_CONFIG`,
);
export const fetchPublicCheckInConfig = makeApiActionCreatorV3(
  api.fetchPublicCheckInConfig,
  FETCH_PUBLIC_CHECK_CONFIG[START],
  FETCH_PUBLIC_CHECK_CONFIG[SUCCESS],
  FETCH_PUBLIC_CHECK_CONFIG[ERROR],
);

export const INSERT_PUBLIC_CHECK_CONFIG = createRequestTypes(
  `${namespace}/INSERT_PUBLIC_CHECK_CONFIG`,
);
export const insertPublicCheckInConfig = makeApiActionCreatorV3(
  api.insertPublicCheckInConfig,
  INSERT_PUBLIC_CHECK_CONFIG[START],
  INSERT_PUBLIC_CHECK_CONFIG[SUCCESS],
  INSERT_PUBLIC_CHECK_CONFIG[ERROR],
);

export const UPDATE_PUBLIC_CHECK_CONFIG = createRequestTypes(
  `${namespace}/UPDATE_PUBLIC_CHECK_CONFIG`,
);
export const updatePublicCheckInConfig = makeApiActionCreatorV3(
  api.updatePublicCheckInConfig,
  UPDATE_PUBLIC_CHECK_CONFIG[START],
  UPDATE_PUBLIC_CHECK_CONFIG[SUCCESS],
  UPDATE_PUBLIC_CHECK_CONFIG[ERROR],
);

export const DELETE_PUBLIC_CHECK_CONFIG = createRequestTypes(
  `${namespace}/DELETE_PUBLIC_CHECK_CONFIG`,
);
export const deletePublicCheckInConfig = makeApiActionCreatorV3(
  api.deletePublicCheckInConfig,
  DELETE_PUBLIC_CHECK_CONFIG[START],
  DELETE_PUBLIC_CHECK_CONFIG[SUCCESS],
  DELETE_PUBLIC_CHECK_CONFIG[ERROR],
);

export const FETCH_WORK_ITEM_DEF_SUBTYPES = createRequestTypes(
  `${namespace}/FETCH_WORK_ITEM_DEF_SUBTYPES`,
);
export const fetchWorkItemDefSubTypes = makeApiActionCreatorV3(
  api.fetchWorkItemDefSubTypes,
  FETCH_WORK_ITEM_DEF_SUBTYPES[START],
  FETCH_WORK_ITEM_DEF_SUBTYPES[SUCCESS],
  FETCH_WORK_ITEM_DEF_SUBTYPES[ERROR],
);

export const FETCH_CHECKIN_CATEGORIES = createRequestTypes(
  `${namespace}/FETCH_CHECKIN_CATEGORIES`,
);
export const fetchCheckInCategories = makeApiActionCreatorV3(
  api.fetchCheckInCategories,
  FETCH_CHECKIN_CATEGORIES[START],
  FETCH_CHECKIN_CATEGORIES[SUCCESS],
  FETCH_CHECKIN_CATEGORIES[ERROR],
);

export const FETCH_PUBLIC_PORTAL_MODE = createRequestTypes(
  `${namespace}/FETCH_PUBLIC_PORTAL_MODE`,
);
export const fetchPublicPortalMode = makeApiActionCreatorV3(
  api.fetchPublicPortalMode,
  FETCH_PUBLIC_PORTAL_MODE[START],
  FETCH_PUBLIC_PORTAL_MODE[SUCCESS],
  FETCH_PUBLIC_PORTAL_MODE[ERROR],
);

export const UPDATE_PUBLIC_PORTAL_MODE = createRequestTypes(
  `${namespace}/UPDATE_PUBLIC_PORTAL_MODE`,
);
export const updatePublicPortalMode = makeApiActionCreatorV3(
  api.updatePublicPortalMode,
  UPDATE_PUBLIC_PORTAL_MODE[START],
  UPDATE_PUBLIC_PORTAL_MODE[SUCCESS],
  UPDATE_PUBLIC_PORTAL_MODE[ERROR],
);


